import { React } from "react";
import { useSelector } from "react-redux";
import PreAssessment from "./preAssessmentStep";
import ClinicalAssessment from "./clinicalAssessmentStep";
import Differential from "./differentialAssessmentStep";
import SignsAndSymptoms from "./signsAndSymptomsStep";
import Treatment from "./treatmentStep";
import Education from "./educationStep";
import Documentation from "./documentationStep";
import { MinorAilmentStep } from "../../../../../helpers/constant";

const MinorAilments = ({}) => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { patient } = useSelector((state) => state.patients);

  if (clinicalServiceObj === null) return null;

  const renderStep = () => {
    const step =
      clinicalServiceObj.initialAssessment.initialAssessmentForm.currentStep ===
      0
        ? 1
        : clinicalServiceObj.initialAssessment.initialAssessmentForm
            .currentStep;
    switch (step) {
      case MinorAilmentStep.PreAssessment:
        return <PreAssessment />;
      case MinorAilmentStep.ClinicalAssessment:
        return <ClinicalAssessment />;
      case MinorAilmentStep.SignsAndSymptoms:
        return <SignsAndSymptoms />;
      case MinorAilmentStep.Differential:
        return <Differential />;
      case MinorAilmentStep.Treatment:
        return <Treatment />;
      case MinorAilmentStep.Education:
        return <Education />;
      case MinorAilmentStep.Documentation:
        return <Documentation />;
    }
  };

  return (
    <div className="bg-gray-20 flex flex-1 w-full">
      <div className="relative flex flex-col w-full gap-4 bg-white">
        <div className="flex flex-col">
          <div className="flex flex-col gap-5">{renderStep()}</div>
        </div>
      </div>
    </div>
  );
};

export default MinorAilments;
